import { useAuthStore } from 'modules/auth/store/authStore';
import { useLibraryStore } from 'modules/library/stores/libraryStore';
import { usePlaybackStore } from 'modules/listening/stores/playback/playbackStore';
import { ItemListenableContent } from 'modules/sdk/lib/facade/listenableContent/item';

export const getIsFreeFirstDocument = () => {
  const { user } = useAuthStore.getState();
  const { userPdfItemsCount } = useLibraryStore.getState();
  const { currentListenableContent: listenableContent } = usePlaybackStore.getState();
  if (listenableContent instanceof ItemListenableContent) {
    const itemId = listenableContent.itemId;
    if (!!user?.firstPdfDocument && !!itemId) {
      return Boolean(itemId === user?.firstPdfDocument);
    } else {
      return listenableContent.isPDF() && userPdfItemsCount === 0;
    }
  }
  return false;
};
